module.exports = __webpack_public_path__ + "img/DigitFrameValues.5fef5aca.png";